import { LOCATION_CHANGE } from 'react-router-redux';

import * as StationConstants from '../../constants';
import * as D from '../../deps';
import * as StationWorkers from '../workers';

export default [
  {
    actionType: D.Constants.Listener.ListenerActions.LISTENER_AUTHENTICATED,
    handler: StationWorkers.initialize,
    concur: 'takeLatest',
  },
  {
    actionType: LOCATION_CHANGE,
    handler: StationWorkers.onLocationChange,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.START_NEXT_NON_SHUFFLE_STATION,
    handler: StationWorkers.startNextNonShuffleStation,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.LOAD_STATIONS,
    handler: StationWorkers.loadStations,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.FETCH_STATIONS_SUCCESS,
    handler: StationWorkers.fetchStationsSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: [
      D.Constants.Api.ApiActions.FETCH_STATIONS_SUCCESS,
      D.Constants.Api.ApiActions.CREATE_STATION_SUCCESS,
    ],
    handler: StationWorkers.fetchStationCurators,
    concur: 'takeLatest',
  },
  {
    actionType: StationConstants.actions.GET_SUGGESTIONS,
    handler: StationWorkers.getSuggestions,
    concur: 'takeEvery',
  },
  {
    actionType: StationConstants.actions.GET_DETAILS,
    handler: StationWorkers.getStationDetails,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_STATION_DETAILS_SUCCESS,
    handler: StationWorkers.getSeedInformation,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_STATION_DETAILS_SUCCESS,
    handler: StationWorkers.fetchStationCurators,
    concur: 'takeEvery',
  },
  {
    actionType: StationConstants.actions.GET_SEEDS,
    handler: StationWorkers.getSeeds,
    concur: 'takeEvery',
  },
  {
    actionType: StationConstants.actions.ADD_SEED,
    handler: StationWorkers.addSeed,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_SEEDS_SUCCESS,
    handler: StationWorkers.getSeedInformation,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_SEEDS_SUCCESS,
    handler: StationWorkers.getSeedsSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.ADD_SEED_SUCCESS,
    handler: StationWorkers.addSeedSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: D.GraphQL.Constants.OperationNameActions.GRAPHQL_ADD_SEED_TO_STATION_SUCCESS,
    handler: StationWorkers.addSeedSuccessGraphQL,
    concur: 'takeEvery',
  },
  {
    actionType: StationConstants.actions.DELETE_SEED,
    handler: StationWorkers.deleteSeed,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.DELETE_SEED_SUCCESS,
    handler: StationWorkers.deleteSeedSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: D.GraphQL.Constants.OperationNameActions.GRAPHQL_DELETE_SEED_FROM_STATION_SUCCESS,
    handler: StationWorkers.deleteSeedSuccessGraphQL,
    concur: 'takeEvery',
  },
  {
    actionType: [
      D.Constants.Api.ApiActions.DELETE_FEEDBACK_SUCCESS,
      D.Constants.Api.ApiActions.ACTION_REMOVE_THUMB_SUCCESS,
    ],
    handler: StationWorkers.deleteFeedbackSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: [
      D.Constants.Api.ApiActions.ADD_FEEDBACK_SUCCESS,
      D.Constants.Api.ApiActions.ACTION_THUMB_UP_SUCCESS,
      D.Constants.Api.ApiActions.ACTION_THUMB_DOWN_SUCCESS,
    ],
    handler: StationWorkers.addFeedbackSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_STATION_FEEDBACK_SUCCESS,
    handler: StationWorkers.getStationFeedbackSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: D.PlaybackConstants.ActionKeys.STATION_SET_PLAYLIST,
    handler: StationWorkers.stationSetPlaylist,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.SET_OR_CREATE_STATION,
    handler: StationWorkers.setOrCreateStationHandler,
    concur: 'takeOnly',
  },
  {
    actionType: 'SET_TRACKS_FOR_STATION',
    handler: StationWorkers.setTracksForStation,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.PLAY_TRACK_FROM_STATION,
    handler: StationWorkers.playStation,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.REGISTER_ARTIST_MESSAGE_METRIC,
    handler: StationWorkers.registerArtistMessageMetric,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Collection.CollectionActions.ADD_COLLECTION_ITEM,
    handler: StationWorkers.maybeAddStationToCollection,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Collection.CollectionActions.REMOVE_COLLECTION_ITEM,
    handler: StationWorkers.maybeRemoveStationFromCollection,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Collection.CollectionActions.REMOVE_STATION_FROM_COLLECTION,
    handler: StationWorkers.confirmRemoveStationFromCollection,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.REGISTER_VOICE_TRACK_METRIC,
    handler: StationWorkers.registerVoiceTrackMetric,
    concur: 'takeEvery',
  },
  {
    actionType: StationConstants.actions.GET_STATION_FEEDBACK,
    handler: StationWorkers.onGetStationFeedback,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.TRACK_THUMBDOWN,
    handler: StationWorkers.trackThumbDown,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.TRACK_THUMBUP,
    handler: StationWorkers.trackThumbUp,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.TRACK_REMOVE_THUMBUP,
    handler: StationWorkers.trackRemoveThumbUp,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.TRACK_REMOVE_THUMBDOWN,
    handler: StationWorkers.trackRemoveThumbDown,
    concur: 'takeOnly',
  },
  {
    actionType: [
      D.Constants.Api.ApiActions.ADD_FEEDBACK_SUCCESS,
      D.Constants.Api.ApiActions.ACTION_THUMB_UP_SUCCESS,
      D.Constants.Api.ApiActions.ACTION_THUMB_DOWN_SUCCESS,
    ],
    handler: StationWorkers.onAddFeedbackSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.TIRE_OF_TRACK,
    handler: StationWorkers.onTrackBecomeTired,
    concur: 'takeOnly',
  },
  {
    actionType: 'START_ADDING_TO_SESSION_HISTORY',
    handler: StationWorkers.addToSessionHistoryUponTrackLoad,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.CONFIRM_REMOVE_STATION,
    handler: StationWorkers.confirmRemoveStation,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.REMOVE_STATION_FROM_SHUFFLE_LIST,
    handler: StationWorkers.removeStationFromShuffleWorker,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.ADD_STATION_TO_SHUFFLE_LIST,
    handler: StationWorkers.addStationToShuffleWorker,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.ADD_ALL_ELIGIBLE_STATIONS_TO_SHUFFLE,
    handler: StationWorkers.addAllStationsToShuffleWorker,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.GET_OR_SET_SHUFFLE_STATIONS_SUCCESS,
    handler: StationWorkers.setShuffleMode,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.CREATE_STATION_SUCCESS,
    handler: StationWorkers.createStationShuffleWorker,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Api.ApiActions.REMOVE_STATION_SUCCESS,
    handler: StationWorkers.setShuffleMode,
    concur: 'takeEvery',
  },
  {
    actionType: D.GraphQL.Constants.OperationNameActions.GRAPHQL_REMOVE_FROM_LIBRARY_SUCCESS,
    handler: StationWorkers.setShuffleMode,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.RESTORE_PREVIOUS_SHUFFLE_CONFIG,
    handler: StationWorkers.restorePreviousShuffleWorker,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.PLAY_NEXT_TRACK,
    handler: StationWorkers.handlePlayNextTrack,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.START_REMOVE_STATION_FLOW,
    handler: StationWorkers.handleRemoveStation,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.PLAYING,
    handler: StationWorkers.handleRemoveArtistAudioMessagesFromPlaylist,
    concur: 'takeOnly',
  },
  {
    // TODO: check on this one (changed action sign)
    actionType: D.Constants.Playback.ActionTypes.CLICKED_ARTIST_AUDIO_MESSAGE,
    handler: StationWorkers.clickedArtistAudioMessage,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.CLICKED_VOICE_TRACK,
    handler: StationWorkers.handleClickedVoiceTrack,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.TRIGGERED_ARTIST_AUDIO_MESSAGE_TILE,
    handler: StationWorkers.handleTriggeredArtistAudioMessageTile,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.TRIGGERED_VOICE_TRACK_TILE,
    handler: StationWorkers.handleTriggeredVoiceTrackTile,
    concur: 'takeOnly',
  },
  {
    actionType: StationConstants.actions.HANDLE_START_STATION_ERROR,
    handler: StationWorkers.startStationErrorHandlers,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.REQUEST_PLAY_TRACK,
    handler: StationWorkers.requestPlayTrack,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.REQUEST_PLAY_TRACK,
    handler: StationWorkers.preStationPlayTrack,
    concur: 'takeEvery',
  },
  {
    actionType: StationConstants.actions.SET_INTERACTIVE_RADIO_MODE,
    handler: StationWorkers.setInteractiveRadioMode,
    concur: 'takeLatest',
  },
  {
    actionType: StationConstants.actions.FETCH_INTERACTIVE_RADIO_MODES,
    handler: StationWorkers.fetchInteractiveRadioModes,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.CREATE_STATION,
    handler: StationWorkers.createStation,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.ROUTE_TO_STATION_DETAILS_FROM_FACTORY_ID,
    handler: StationWorkers.routeToStationDetailsFromFactoryId,
    concur: 'takeEvery',
  },
  {
    actionType: D.PlaybackConstants.ActionKeys.LOAD_STATION_RECOMMENDATIONS,
    handler: StationWorkers.loadStationRecommendations,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.SET_OR_CREATE_STATION_FINISHED,
    handler: StationWorkers.openDiscoveryTunerModalOnInitialPlay,
    concur: 'takeOnce',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.UPDATE,
    handler: StationWorkers.preloadNextTrack,
    concur: 'throttle',
    wait: 5000, // 5 seconds
  },
];
